/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Compliance metrics */
export type ComplianceMetrics = {
  /** Compliance score (0-100) */
  complianceScore: number;
  /** Policy adherence rate */
  policyAdherenceRate: number;
  /** Incident response time (average seconds) */
  avgIncidentResponseTime: bigint;
  /** False positive rate */
  falsePositiveRate: number;
  /** Coverage percentage */
  coveragePercentage: number;
  /** Audit readiness score */
  auditReadinessScore: number;
};

export type ComplianceMetricsArgs = {
  /** Compliance score (0-100) */
  complianceScore: number;
  /** Policy adherence rate */
  policyAdherenceRate: number;
  /** Incident response time (average seconds) */
  avgIncidentResponseTime: number | bigint;
  /** False positive rate */
  falsePositiveRate: number;
  /** Coverage percentage */
  coveragePercentage: number;
  /** Audit readiness score */
  auditReadinessScore: number;
};

export function getComplianceMetricsEncoder(): FixedSizeEncoder<ComplianceMetricsArgs> {
  return getStructEncoder([
    ["complianceScore", getU8Encoder()],
    ["policyAdherenceRate", getU8Encoder()],
    ["avgIncidentResponseTime", getU64Encoder()],
    ["falsePositiveRate", getU8Encoder()],
    ["coveragePercentage", getU8Encoder()],
    ["auditReadinessScore", getU8Encoder()],
  ]);
}

export function getComplianceMetricsDecoder(): FixedSizeDecoder<ComplianceMetrics> {
  return getStructDecoder([
    ["complianceScore", getU8Decoder()],
    ["policyAdherenceRate", getU8Decoder()],
    ["avgIncidentResponseTime", getU64Decoder()],
    ["falsePositiveRate", getU8Decoder()],
    ["coveragePercentage", getU8Decoder()],
    ["auditReadinessScore", getU8Decoder()],
  ]);
}

export function getComplianceMetricsCodec(): FixedSizeCodec<
  ComplianceMetricsArgs,
  ComplianceMetrics
> {
  return combineCodec(
    getComplianceMetricsEncoder(),
    getComplianceMetricsDecoder(),
  );
}
